export type Tool = {
  slug: string
  title: string
  tag: string
  tagFr: string
  /** short card copy (hub + homepage) */
  body: string
  bodyFr: string
  /** hero paragraph on the tool's own page */
  hero: string
  heroFr: string
  /** "what it does" bullets */
  does: string[]
  doesFr: string[]
  /** who it's for */
  audience: string
  audienceFr: string
}

export const tools: Tool[] = [
  {
    slug: 'payroll-calculator',
    title: 'Payroll Calculator',
    tag: 'All provinces',
    tagFr: 'Toutes les provinces',
    body: 'Run a full payroll calculation for any province — CPP, EI, federal and provincial tax. Print stubs & cheques.',
    bodyFr: "Effectuez un calcul complet de paie pour n'importe quelle province — RPC, AE, impôt fédéral et provincial. Imprimez talons et chèques.",
    hero: 'A complete gross-to-net payroll calculation for any province or territory — the same engine that powers SimplePay, free to use.',
    heroFr: "Un calcul complet de la paie, du brut au net, pour n'importe quelle province ou territoire — le même moteur qui propulse SimplePay, gratuit à utiliser.",
    does: [
      'Gross-to-net calculations for every province and territory, including Quebec',
      'CPP, EI, federal and provincial tax broken down line by line',
      'Printable pay stubs and cheques, ready to hand over',
    ],
    doesFr: [
      'Calculs du brut au net pour chaque province et territoire, y compris le Québec',
      'RPC, AE, impôt fédéral et provincial détaillés ligne par ligne',
      'Talons de paie et chèques imprimables, prêts à remettre',
    ],
    audience:
      'Employers checking a run, employees double-checking a paycheque, and accountants modelling scenarios.',
    audienceFr:
      "Employeurs vérifiant un cycle, employés vérifiant un chèque de paie, et comptables modélisant des scénarios.",
  },
  {
    slug: 'cheque-print',
    title: 'Cheque Print',
    tag: 'Free',
    tagFr: 'Gratuit',
    body: 'Print a custom cheque, formatted and ready.',
    bodyFr: 'Imprimez un chèque personnalisé, formaté et prêt.',
    hero: 'Print a custom cheque — payee, amount in words, date and memo — correctly formatted and ready to sign.',
    heroFr: 'Imprimez un chèque personnalisé — bénéficiaire, montant en lettres, date et mémo — correctement formaté et prêt à signer.',
    does: [
      'Payee, numeric amount and amount-in-words filled automatically',
      'Date and memo fields, laid out for standard cheque stock',
      'A clean, bank-ready cheque every time',
    ],
    doesFr: [
      'Bénéficiaire, montant numérique et montant en lettres remplis automatiquement',
      'Champs de date et de mémo, adaptés aux chèques standard',
      'Un chèque propre, prêt pour la banque, à chaque fois',
    ],
    audience:
      'Anyone who still needs the occasional paper cheque — without keeping a cheque writer around.',
    audienceFr:
      "Quiconque a encore besoin d'un chèque papier à l'occasion — sans garder de machine à chèques.",
  },
  {
    slug: 'verify',
    title: 'Verify',
    tag: 'CRA & Quebec',
    tagFr: 'ARC et Québec',
    body: 'Verify SIN, BN, identification & file numbers, and Quebec Enterprise Number.',
    bodyFr: "Vérifiez le NAS, le NE, les numéros d'identification et de dossier, ainsi que le numéro d'entreprise du Québec (NEQ).",
    hero: 'Check the numbers before they cost you a rejected filing — validate SINs, Business Numbers and Quebec Enterprise Numbers instantly.',
    heroFr: "Vérifiez les numéros avant qu'ils ne vous coûtent une déclaration rejetée — validez instantanément les NAS, les numéros d'entreprise et les numéros d'entreprise du Québec.",
    does: [
      'Social Insurance Number (SIN) validation',
      'Business Number and CRA identification & file number checks',
      'Quebec Enterprise Number (NEQ) validation',
    ],
    doesFr: [
      "Validation du numéro d'assurance sociale (NAS)",
      "Vérification du numéro d'entreprise et des numéros d'identification et de dossier de l'ARC",
      "Validation du numéro d'entreprise du Québec (NEQ)",
    ],
    audience:
      'Payroll and HR teams onboarding employees or setting up remittance accounts.',
    audienceFr:
      'Équipes de paie et RH qui accueillent des employés ou configurent des comptes de remise.',
  },
]

export function getTool(slug: string | undefined) {
  return tools.find((t) => t.slug === slug)
}
